import { Controller } from "stimulus"
import * as utilities from "../src/utilities.js"

export default class extends Controller{

  beforeInputFormatNumber(event){

    // we want to allow a percentage with a tenths decimal digit as well
    // we also allow various degenerate strings such as "", ".", and, e.g., "8."

    const result = utilities.textAfterInput(event);  // what would the text be after applying it to the input?

    if (!result.match(/^\d{0,2}(\.\d?)?$/))
      event.preventDefault();
  }
}
